import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const nav = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="section-sand min-h-[70vh] flex items-center justify-center py-16 px-4">
      <div className="bg-white rounded-3xl shadow-card border border-border p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-5">
          <XCircle className="w-11 h-11 text-destructive" />
        </div>
        <h1 className="font-heading font-extrabold text-2xl text-ink">{t("payment.cancel")}</h1>
        <p className="text-muted2 font-body mt-3">{t("payment.cancelText")}</p>
        <Button data-testid="cancel-back-button" onClick={() => nav("/search")} className="mt-6 rounded-full bg-canard hover:bg-canard-dark">{t("nav.vehicles")}</Button>
      </div>
    </div>
  );
}
